// Lead-magnet form → same contact Lambda as #contact, with `type: "checklist"`.
// The Lambda mails the request, and the checklist is sent by hand, so the
// confirmation promises a mail rather than an instant download.
import { recaptchaToken, resetRecaptcha, postForm } from "./recaptcha.js"

export default function initLeadMagnet() {
  const forms = document.querySelectorAll("[data-lead-magnet]")
  if (!forms.length) return

  forms.forEach((form) => {
    const endpoint = form.getAttribute("data-endpoint")
    const button = form.querySelector("[data-lead-submit]")
    const status = form.querySelector("[data-lead-status]")
    const originalLabel = button ? button.textContent.trim() : "Download de checklist"

    const setStatus = (msg, ok) => {
      if (!status) return
      status.textContent = msg
      status.classList.remove("hidden", "text-emerald-600", "text-red-600")
      status.classList.add(ok ? "text-emerald-600" : "text-red-600")
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault()
      if (!endpoint || !button) return

      const token = recaptchaToken(form)
      if (!token) {
        setStatus("Vink eerst aan dat je geen robot bent.", false)
        return
      }

      button.disabled = true
      button.textContent = "Versturen…"

      const res = await postForm(endpoint, {
        type: "checklist",
        naam: form.elements.name.value,
        email: form.elements.email.value,
        company: form.elements.company ? form.elements.company.value : "",
        token,
      })
      resetRecaptcha(form)

      if (res.ok) {
        form.reset()
        button.textContent = "Aangevraagd ✓"
        button.classList.add("bg-emerald-500")
        setStatus("Dank je. We mailen je de checklist zo snel mogelijk.", true)
      } else {
        button.disabled = false
        button.textContent = originalLabel
        setStatus(res.message || "Versturen is niet gelukt. Probeer het later nog eens.", false)
      }
    })
  })
}
